Ext.define('SA.view.legend.ColorRanges', {
    alias: 'widget.legend-color-ranges',
    extend: 'Ext.Component',

    autoEl: 'ul',
    cls: 'sa-legend-ranges',
    margin: '0 11 5',

    rowSpec: {
        cls: 'sa-legend-range',
        tag: 'li',

        html: [
            '<span class="sa-legend-color-block-wrap">',
                '<span class="sa-legend-color-block"></span>',
            '</span>',
            '<span class="sa-legend-range-text">',
                '<span class="sa-legend-range-text-lower"></span>',
                '<span class="sa-legend-range-text-separator"> - </span>',
                '<span class="sa-legend-range-text-upper"></span>',
                '<input class="sa-legend-range-input">',
            '</span>'
        ].join('')
    },

    initEvents() {
        this.el.on({
            delegate: '.sa-legend-color-block',
            scope: this,

            click: this.onColorBlockClick,
            mouseout: this.onColorBlockMouseOut,
            mouseover: this.onColorBlockMouseOver
        });

        this.el.dom.addEventListener('blur', this.onRangeInputBlur.bind(this), true);

        this.el.on({
            delegate: '.sa-legend-range-input',
            scope: this,

            keypress: this.onRangeInputKeyPress
        });
    },

    isRangesInvalid() {
        return this.rangesInvalid;
    },

    onColorBlockClick(ev) {
        var legend = this.up('map-legend'),
            index = ev.getTarget('[data-index]').getAttribute('data-index') - 1,
            map = legend.map,
            ranges = map.getLegendBreaks();

        if (legend.isDrag) {
            return;
        }

        legend.addCls('sa-legend-active');

        SA.view.color.ColorWindow.show({
            color: ranges.colors[index],

            hide() {
                legend.removeCls('sa-legend-active');
            },

            select(color) {
                var colors = ranges.colors.slice();

                colors[index] = color.toLowerCase();

                map.setLegend({colors});
            }
        }).showBy(ev.getTarget('.sa-legend-color-block-wrap'), 'r-l?');
    },

    onColorBlockMouseOut(ev) {
        Ext.fly(ev.getTarget('.sa-legend-color-block-wrap')).removeCls('sa-legend-color-block-wrap-over');
    },

    onColorBlockMouseOver(ev) {
        Ext.fly(ev.getTarget('.sa-legend-color-block-wrap')).addCls('sa-legend-color-block-wrap-over');
    },

    onRangeInputBlur() {
        var legend = this.up('map-legend'),
            map = legend.map,
            Attributes = SA.data.AttributesCache,
            attribute = Attributes.get(map.getAttribute()),
            increment = +attribute.increments,
            roundingFactor = 1 / increment,
            breaks = map.getLegendBreaks(),
            settings = map.getLegendSettings(),
            min = settings.minimum,
            max = settings.maximum,
            inputs = this.el.query('.sa-legend-range-input'),
            invalid = false,
            values, fullValues;

        inputs.pop();

        values = inputs.map(input => {
            var value = input.value,
                num = null;

            value = value.replace(/[^\-\d\.]/g, '');

            if (value) {
                num = +value + increment;

                if (num === num) {
                    num = round(num);
                }
                else {
                    num = null;
                }
            }

            return num;
        });

        fullValues = [min].concat(values).concat(max + increment);

        values.forEach((value, index) => {
            if (value == null || value <= fullValues[index] || value >= fullValues[index + 2]) {
                invalid = true;

                Ext.fly(inputs[index]).addCls('sa-legend-range-input-invalid');
            }
            else {
                Ext.fly(inputs[index]).removeCls('sa-legend-range-input-invalid');
            }
        });

        this.rangesInvalid = invalid;

        if (Ext.Array.equals(values, breaks.breaks)) {
            legend.refresh();

            return;
        }

        if (invalid) {
            if (settings.classificationMethod !== 'custom') {
                map.setLegend({
                    breaks: breaks.breaks
                });
            }
            else {
                legend.refresh();
            }
        }
        else {
            map.setLegend({
                breaks: values
            });
        }

        Ext.EventManager.idleEvent.fire();

        function round(value) {
            return Math.round(value * roundingFactor) / roundingFactor;
        }
    },

    onRangeInputKeyPress(ev) {
        if (ev.ctrlKey || ev.altKey) {
            return;
        }

        var code = ev.charCode;

        if (code) {
            if (!/[\d\.\$,\-%]/.test(String.fromCharCode(code))) {
                ev.stopEvent();
            }
        }
    },

    refresh() {
        var legend = this.up('map-legend'),
            map = legend.map,
            Attributes = SA.data.AttributesCache,
            attributeId = map.getAttribute(),
            unit = map.getGeographicUnit(),
            attribute = Attributes.get(attributeId),
            editMode = legend.editMode,
            legendBreaks = map.getLegendBreaks(),
            legendSettings = map.getLegendSettings(),
            rows = this.rows || (this.rows = []),
            updateValues, outline, colors, lastBreak, nextBreak, increment, formatString, breaks, row,
            lower, upper, lastLegend, isLastRow, isSameValue;

        if (legendSettings && legendBreaks && attribute) {
            let len = legendBreaks.numberOfRanges;

            formatString = attribute.formatString;
            increment = +attribute.increments;

            outline = legendSettings.outline;
            colors = legendBreaks.colors;
            lastBreak = legendSettings.minimum;
            breaks = legendBreaks.breaks.concat(legendSettings.maximum + increment);

            lastLegend = {
                attribute: attributeId,
                geographicUnit: unit,
                numberOfRanges: legendSettings.numberOfRanges
            };

            updateValues = !(
                editMode
                && this.isRangesInvalid()
                && legendSettings.classificationMethod === 'custom'
                && Ext.Object.equals(lastLegend, this.lastLegend)
            );

            this.lastLegend = lastLegend;

            while (rows.length > len) {
                Ext.removeNode(rows.pop());
            }

            while (rows.length < len) {
                rows.push(Ext.DomHelper.append(this.el, this.rowSpec));
            }

            for (let index = 0 ; index < len ; ++index) {
                if (index === len - 1) {
                    isLastRow = true;
                }

                row = rows[index];
                nextBreak = breaks[index];

                lower = lastBreak == null ? '' : Attributes.formatValue(lastBreak, formatString);
                upper = nextBreak == null ? '' :  Attributes.formatValue(nextBreak - increment, formatString);

                isSameValue = lower === upper;

                Ext.fly(row).down('.sa-legend-color-block').setStyle({
                    backgroundColor: '#' + colors[index],
                    border: outline.width + 'px solid #' + outline.color
                });

                Ext.fly(row).set({'data-index': index + 1});
                Ext.fly(row).down('.sa-legend-range-text-lower').update(lower);
                Ext.fly(row).down('.sa-legend-range-text-separator').setStyle('visibility', !isSameValue || (editMode && !isLastRow) ? 'visible' : 'hidden');
                Ext.fly(row).down('.sa-legend-range-text-upper').update(upper).setStyle('visibility', !editMode && !isSameValue ? 'visible' : 'hidden');
                Ext.fly(row).down('.sa-legend-range-input').setStyle('visibility', editMode && !(isLastRow && isSameValue) ? 'visible' : 'hidden').set({disabled: isLastRow});

                if (updateValues) {
                    Ext.fly(row).down('.sa-legend-range-input').set({value: upper}, false).removeCls('sa-legend-range-input-invalid');
                }

                lastBreak = nextBreak;
            }

            if (updateValues) {
                this.rangesInvalid = false;
            }

            this.setLoading(false);
        }
    },

    setLoading(maybeText) {
        if (maybeText === false) {
            this.unmask();
        }
        else {
            this.getEl().mask(maybeText);
        }
    }
});